import React from "react";
import "./index.scss";

import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { Collapse } from "antd";

const { Panel } = Collapse;

const FAQs = (props) => {
  const callback = (key) => {
    console.log(key);
  };
  return (
    <div className="faqs" ref={props.faqRef}>
      <div className="content">
        <h2>Frequently asked questions</h2>

        <Collapse
          defaultActiveKey={[0]}
          onChange={callback}
          expandIconPosition="right"
          expandIcon={({ isActive }) =>
            isActive ? <MinusOutlined /> : <PlusOutlined />
          }
        >
          <Panel header="What is Precog.finance?">
            <p>
              Precog.finance is an ecosystem which automates crypto arbitrage
              trading, using sophisticated AI and Financial Engineering. We help
              to automatically trade arbitrage in a way that’s never been done
              before. We aim to leverage on price differences between exchange
              pairs (i.e., BTC and USD), but across several exchanges.
            </p>
          </Panel>

          <Panel header="What is “Slippage” and how does it relate to Precog.finance?">
            <p>
              In trading, Slippage refers to “the difference between the
              expected price of a trade and the price at which the trade is
              executed. Slippage can occur at any time but is most prevalent
              during periods of higher volatility when market orders are used.
              It can also occur when a large order is executed but there isn’t
              enough volume at the chosen price to maintain the current bid/ask
              spread.”{" "}
            </p>
            <p>
              We acknowledge that prices on exchange i.e., Binance & Kraken as
              well as lending protocols are not always the same. When there are
              price movements, there are opportunities to execute a safe trade.
              If there is 0,2% slippage, then there is 0,2% profit!
            </p>
            <p>
              As mentioned above, we are currently in the research and
              development phase, and thus for now, this is the foundation from
              which we are conducting our analysis.
            </p>
          </Panel>

          <Panel header="How do we incorporate Futures and lending opportunities?">
            <p>
              Now that we have established the ability to spot the price
              opportunities on the trading pairs, we are able to go into the
              future pricing. We will also be experimenting with lending
              opportunities.
            </p>

            <p>
              In trading, Futures pricing refers to “an agreed-upon price in a
              contract (called a futures contract) between two parties for the
              sale and delivery of the asset at a specified time later on.”
              Investopedia
            </p>

            <p>
              With futures pricing, there is always opportunity for slippage, as
              there is always prediction at play. We can identify the same type
              of slippage in this case, as in the case above.
            </p>

            <p>
              Example: Bitcoin is at $32k, but a future contract is $32,5k.
              There is a price slippage opportunity present, and our platform
              will be able to leverage this automatically, using AI and
              sophisticated financial engineering.
            </p>
          </Panel>

          <Panel header="What slippage opportunities do we want to cater for?">
            <p>
              {" "}
              As the intelligence of the platform develops, we will want to
              cater for the above-mentioned slippage opportunity. We will start
              with BTC, ETH, USDC and all different types of trading pairs and
              opportunities. This is the base of the mechanism.
            </p>
            <p>
              After this, we add the DeFi exchanges such as UniSwap, SushiSwap
              etc — as there are also arbitrage opportunities present there.
            </p>
          </Panel>

          <Panel header="What do we offer the regular user?">
            <p>
              Instead of jumping around various exchanges and trying to
              establish the best DeFi project with the biggest yield,
              individuals can invest in the Precog.finance with a certain
              amount, in exchange for a token.
            </p>
          </Panel>

          <Panel header="The Precog.finance token explained ">
            <p>
              Investors can invest their money into the Precog.finance platform
              i.e. bring liquidity to the platform, and in exchange are given a
              token. The money is managed through the Precog.finance platform,
              and the value is inserted back into the token. The algorithm
              scouts for sustainable opportunities.
            </p>

            <p>
              The gains of the fund management are stored in the token, and we
              as Precog.finance offer the opportunity to purchase the token back
              from users at a higher price — so that they receive the gains of
              their investment. Instead of users getting their money back, the
              token increases in value. They can sell the token for money. We
              are still exploring different models of exit mechanisms.
            </p>
          </Panel>

          <Panel header="Step by step guide on how the token works ">
            <ol>
              <li>
                <p> Users buy tokens (i.e. invest)</p>
              </li>
              <li>
                <p>
                  Precog.finance automatically trades futures / arbitrage and
                  returns on the investments are earned
                </p>
              </li>
              <li>
                <p>
                  The value from the returns is inserted into the token i.e. the
                  token value increases as returns are earned
                </p>
              </li>
              <li>
                <p>Users can withdraw and sell tokens at any time</p>
              </li>
              <li>
                <p>The Yield is calculated at the end</p>
              </li>
              <li>
                <p>
                  The token gains in value from the profit traded by the pool
                </p>
              </li>
            </ol>
          </Panel>

          <Panel header="Why is it currently impossible to manually trade arbitrage?">
            <p>
              Individuals can technically manually trade arbitrage, but not at
              the speed at which a trading algorithm is able to trade. These
              movements are faster than the time it takes to click / execute
              etc. One minute the opportunity is there, and one minute it is
              not. A manual trader cannot cover all the opportunities by
              themselves.
            </p>

            <ul>
              <li>
                <p>We can spot within a second</p>
              </li>
              <li>
                <p>
                  The manual trader needs to take time to click - this takes up
                  precious time!!
                </p>
              </li>
            </ul>
          </Panel>

          <Panel header="How is the Precog.finance ecosystem different to a bot?">
            <p>
              In the current market, it is difficult to survive without
              deploying a bot. A bot is basic and needs to be deployed. The bot
              ecosystem is different in different organizations, and this is
              what gives winners an edge. Previously, only large hedge funds and
              organizations could deploy bots, but now the larger population has
              access, and this is due to the democratization of finance that
              DeFi brings.
            </p>
            <p>
              Precog.finance is different to a bot as it employs AI and
              financial engineering to continuously refine the trading strategy.
              A bot only can apply one strategy at a time, however the
              Precog.finance strategy is constantly being refined due to AI and
              financial engineering.{" "}
            </p>
          </Panel>

          {/* <Panel header="Is trading arbitrage a new concept?">
            <p></p>No, trading arbitrage is not a new concept. Arbitrage trading
            has been present in the traditional financial markets for many
            years, however there is no longer much opportunity in these
            mainstream markets.
          </Panel> */}

          {/* {data.map((item, i) => (
            <Panel header={item.question} key={i}>
              <p>{item.answer}</p>
            </Panel>
          ))} */}
        </Collapse>
      </div>
    </div>
  );
};

export default FAQs;
